module.exports = __webpack_public_path__ + "8321b3c5fc0752b140c703d24917084a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/eyes.png
// module id = 1757
// module chunks = 0